/**
 * Werkzeuge auf dem Wald-Kopf (Baukasten, Board „Belegung“/„Vertrieb“): durchscheinende Gruppe,
 * runde Pfeile, „Heute“ als weißer Knopf und die Längenwahl mit weißem aktivem Feld. Belegung,
 * Verfügbarkeit & Vertrieb und Preisautomatik nutzen dieselben Bausteine.
 */
import { cn } from '@/shared/lib/cn';

export const forestGroup =
  'rounded-pill flex items-center border border-white/15 bg-white/[0.08] text-white';
export const forestArrow =
  'rounded-pill grid size-11 flex-none place-items-center text-white hover:bg-white/10';

export function ForestTodayButton({
  onToday,
  className,
}: {
  onToday: () => void;
  className?: string;
}) {
  return (
    <button
      type="button"
      onClick={onToday}
      className={cn(
        'rounded-pill text-forest-deep h-11 bg-white px-4 text-sm font-bold hover:bg-white/90',
        className,
      )}
    >
      Heute
    </button>
  );
}

/** Längenwahl als Radiogruppe („7 T · 14 T …“); `value` null, wenn ein freier Zeitraum gilt. */
export function ForestLengthGroup<T extends number>({
  values,
  value,
  onChange,
  label = 'Zeitraum',
}: {
  values: readonly T[];
  value: T | null;
  onChange: (value: T) => void;
  label?: string;
}) {
  return (
    <div role="radiogroup" aria-label={label} className={cn(forestGroup, 'gap-0.5 p-1')}>
      {values.map((option) => {
        const active = value === option;
        return (
          <button
            key={option}
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => onChange(option)}
            className={cn(
              // Sichtbar 36 px; die Trefferfläche reicht über das Polster der Gruppe auf 44 px (§9).
              "rounded-pill relative h-9 px-3 font-mono text-xs font-semibold before:absolute before:-inset-y-1 before:inset-x-0 before:content-['']",
              active ? 'text-forest-deep bg-white' : 'text-white hover:bg-white/10',
            )}
          >
            {option} T
          </button>
        );
      })}
    </div>
  );
}
